"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _getPrototypeOf = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BackgroundFilterVideoFrameProcessor_1 = require("../backgroundfilter/BackgroundFilterVideoFrameProcessor");

var ConsoleLogger_1 = require("../logger/ConsoleLogger");

var LogLevel_1 = require("../logger/LogLevel");

var NoOpVideoFrameProcessor_1 = require("../videoframeprocessor/NoOpVideoFrameProcessor");

var BackgroundBlurProcessorBuiltIn_1 = require("./BackgroundBlurProcessorBuiltIn");

var BackgroundBlurProcessorProvided_1 = require("./BackgroundBlurProcessorProvided");

var BackgroundBlurStrength_1 = require("./BackgroundBlurStrength");
/**
 * No-op implementation of the blur processor. An instance of this class will be returned when a user attempts
 * to create a blur processor when it is not supported.
 */

/** @internal */


var NoOpBackgroundBlurProcessor = /*#__PURE__*/function (_NoOpVideoFrameProces) {
  _inherits(NoOpBackgroundBlurProcessor, _NoOpVideoFrameProces);

  var _super = _createSuper(NoOpBackgroundBlurProcessor);

  function NoOpBackgroundBlurProcessor() {
    _classCallCheck(this, NoOpBackgroundBlurProcessor);

    return _super.apply(this, arguments);
  }

  _createClass(NoOpBackgroundBlurProcessor, [{
    key: "setBlurStrength",

    /**
     * no-op
     */
    value: function setBlurStrength() {}
    /**
     * no-op
     * @returns
     */

  }, {
    key: "loadAssets",
    value: function loadAssets() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * no-op
     */

  }, {
    key: "addObserver",
    value: function addObserver() {}
    /**
     * no-op
     */

  }, {
    key: "removeObserver",
    value: function removeObserver() {}
  }]);

  return NoOpBackgroundBlurProcessor;
}(NoOpVideoFrameProcessor_1.default);
/**
 * [[BackgroundBlurVideoFrameProcessor]]
 * Creates a background blur processor which identifies the foreground person and blurs the background.
 */


var BackgroundBlurVideoFrameProcessor = /*#__PURE__*/function (_BackgroundFilterVide) {
  _inherits(BackgroundBlurVideoFrameProcessor, _BackgroundFilterVide);

  var _super2 = _createSuper(BackgroundBlurVideoFrameProcessor);

  function BackgroundBlurVideoFrameProcessor() {
    _classCallCheck(this, BackgroundBlurVideoFrameProcessor);

    return _super2.apply(this, arguments);
  }

  _createClass(BackgroundBlurVideoFrameProcessor, null, [{
    key: "create",

    /**
     * A factory method that will call the private constructor to instantiate the processor and asynchronously
     * initialize the worker, wasm, and ML models. Upon completion of the initialization the promise will either
     * be resolved or rejected.
     * @param spec The spec defines the assets that will be used for adding background blur to a frame
     * @param blurStrength How much blur to apply to a frame
     * @returns
     */
    value: function create(spec, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _options, logger, supported, processor;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                spec = BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
                options = BackgroundBlurVideoFrameProcessor.resolveOptions(options);
                _options = options, logger = _options.logger;
                _context2.next = 5;
                return BackgroundBlurVideoFrameProcessor.isSupported(spec, options);

              case 5:
                supported = _context2.sent;
                // if blur is not supported do not initialize. The processor will become a no op if not supported.
                logger.info("processor is ".concat(supported ? '' : 'not', " supported"));

                if (supported) {
                  _context2.next = 10;
                  break;
                }

                logger.warn('Using no-op processor because background blur is not supported');
                return _context2.abrupt("return", new NoOpBackgroundBlurProcessor());

              case 10:
                _context2.next = 12;
                return BackgroundBlurProcessorProvided_1.default.isSupported();

              case 12:
                if (!_context2.sent) {
                  _context2.next = 17;
                  break;
                }

                logger.info('Using browser-provided background blur');
                processor = new BackgroundBlurProcessorProvided_1.default(spec, options);
                _context2.next = 19;
                break;

              case 17:
                logger.info('Using built-in background blur');
                processor = new BackgroundBlurProcessorBuiltIn_1.default(spec, options);

              case 19:
                _context2.next = 21;
                return processor.loadAssets();

              case 21:
                return _context2.abrupt("return", processor);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Based on the options that are passed in set defaults for options
     * @param options  the options that are passed in
     * @returns An updated set of options with defaults set
     */

  }, {
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!options.blurStrength) {
        options.blurStrength = BackgroundBlurStrength_1.default.MEDIUM;
      }

      if (!options.logger) {
        options.logger = new ConsoleLogger_1.default('BackgroundBlurProcessor', LogLevel_1.default.INFO);
      }

      options = _get(_getPrototypeOf(BackgroundBlurVideoFrameProcessor), "resolveOptions", this).call(this, options);
      return options;
    }
    /**
     * This method will detect the environment in which it is being used and determine if background
     * blur can be used.
     * @param spec The {@link BackgroundBlurSpec} spec that will be used to initialize assets
     * @param options options such as logger
     * @returns a boolean promise that will resolve to true if supported and false if not
     */

  }, {
    key: "isSupported",
    value: function isSupported(spec, options) {
      spec = BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
      options = BackgroundBlurVideoFrameProcessor.resolveOptions(options);
      return _get(_getPrototypeOf(BackgroundBlurVideoFrameProcessor), "isSupported", this).call(this, spec, options);
    }
  }]);

  return BackgroundBlurVideoFrameProcessor;
}(BackgroundFilterVideoFrameProcessor_1.default);

exports.default = BackgroundBlurVideoFrameProcessor;